module.exports = {"GBP":"£","AUD":"A$","EUR":"€","JPY":"¥","SEK":"kr","USD":"$","SGD":"S$","HKD":"HK$","NG":"₦","LEI":"lei","BGN":"лв","BRL":"R$","KES":"KSh","CZK":"Kč"}


//////////////////
// WEBPACK FOOTER
// ./src/data/currencies.json
// module id = 580
// module chunks = 0